export interface ShareLinkPayload {
  name: string;
  url: string;
  imageUrl?: string;
  videoUrl?: string;
  canonicalUrl?: string;
}

export interface ShareLinkRedirectBody {
  siteId: string;
  subSiteId?: string | null;
  source: string;
  entity: ShareLinkEntity;
}

interface ShareLinkEntity {
  id: string;
  type: ShareLinkType;
  parentId?: string;
}

export enum ShareLinkType {
  ProductList = 'productList',
  LookBookProductList = 'lookBook_ProductList',
}
